<template>
	<div>
		<van-nav-bar
			title="我的收藏"
			left-text="返回"
			left-arrow
			@click-left="onClickLeft"
		/>
		<van-grid :column-num="2" class="grid-cabinet">
			<van-grid-item v-for="d in orders" v-bind:key="d.id">
				<van-image radius="10" class="img-book-cover" :src="d.cover" />
				<div class="book-name">{{ d.bookName }}</div>
			</van-grid-item>
		</van-grid>
	</div>
</template>

<script>
import {
	Row,
	Col,
	Form,
	NavBar,
	Field,
	Button,
	Picker,
	Popup,
	Area,
	Toast,
	Grid,
	GridItem,
	Image as VanImage,
} from "vant";
import { Get, Post } from "@/utils/Api";

export default {
	components: {
		[Row.name]: Row,
		[Col.name]: Col,
		[Form.name]: Form,
		[Field.name]: Field,
		[NavBar.name]: NavBar,
		[Button.name]: Button,
		[Picker.name]: Picker,
		[Popup.name]: Popup,
		[Area.name]: Area,
		[Grid.name]: Grid,
		[GridItem.name]: GridItem,
		[VanImage.name]: VanImage,
	},
	data() {
		return {
			wishes: [],
		};
	},
	created: function() {
		console.log("CREATED");
	},
	mounted: function() {
		console.log("MOUNTED");
		this.loadWishes();
	},
	methods: {
		onConfirm(value) {
			this.value = value;
			this.showPicker = false;
		},
		onSubmit(values) {
			console.log("submit", values);

			console.log(this.classId, this.code);

			var openId = localStorage.getItem("openId");

			Post(
				"bindStudent",
				{
					schoolId: this.schoolId,
					classId: this.classId,
					realName: this.code,
					code: this.code,
					openId: openId,
				},
				(res) => {
					var r = res.data;
					if (r.success) {
						Toast.success(r.msg);
						this.$router.push({
							path: "/user",
						});
					} else {
						Toast.fail(r.msg);
					}
					console.log("绑定学生", res.data);
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},
		loadWishes() {
			var openId = localStorage.getItem("openId");

			Get(
				"queryWish",
				{
					openId: openId,
				},
				(res) => {
					console.log("load wishes", res.data.data);
					this.wishes = res.data.data;
				},
				(res) => {
					console.log("ERROR", res);
				}
			);
		},
		onClickLeft: function() {
			this.$router.push({ name: "user" });
		},
	},
};
</script>

<style scoped>
.btn_register {
	margin-top: 20px;
}
</style>
